import { $ } from '../vendors/jquery';

class Comments
{
    constructor( element ) 
    {
        this.element  = element;
        this.reply = this.element.find( '[data-respondelement="respond"]' );

        this.init();
    }

    init() 
    {
        this.reply.on( 'click', this.resetFormValidation );
    }

    resetFormValidation() 
    {
        $( '.gform_validation_errors' ).hide();
        $( '.gfield_validation_message' ).hide();
    }
}

const comments = {
    init() {
        const commentsElement = $( '[data-module="comments"]' );

        if ( null !== commentsElement ) {
            new Comments( $( commentsElement ) );
        }
    }
};

export default comments;
